<main class="">

    <header class="p-2">

        <img src="../../../assets/Img/station.png" alt="">

        <p *ngIf="strStationName != '' " class="position-relative"> 
            
            {{ strStationName | faNum }}

            <!-- <img class="map-arrow" src="../../../assets/Img/dotted-arrow.png" alt=""> -->

            <!-- <span class="you-here"> شما اینجا هستید </span> -->
        
        </p>

        <span> {{ todayDateFull | faNum }}</span>

    </header>


    <section class="section-container">

        <div *ngFor="let item of lstRoute" class="mx-auto row gx-0">

            <div class="img-container col-4 col-md-2 ">

                <img class="w-100 h-100" src="../../../assets/Img/vip-bus.png" alt="">

            </div>

            <div class="ticket-info col-12 col-md-10">

                <div class="col-12 d-flex align-items-center mb-3">

                    <span class="fw-bold text-muted" 
                    
                    style="text-wrap: nowrap;overflow: hidden;text-overflow: ellipsis;max-width: 40vw;">
                    
                    {{ item.strSourceStationName }} 
                
                </span>

                    <span class="mx-1 mx-md-2"></span>

                    <!-- <i class="mx-1 dot"></i> -->

                    <span class="position-relative">

                         <!-- <span>  - - -  </span> -->

                    </span>

                    <span class="mx-1"> ⟵ </span>

                    <span class="mx-1 mx-md-2"></span>

                    <span class="fw-bold text-muted" 
                    
                        style="text-wrap: nowrap;overflow: hidden;text-overflow: ellipsis;max-width: 40vw;">
                        
                        {{ item.strDestinationStationName }} 
                    
                    </span>

                
                </div>

                <p class=""> 
                    
                    <i class="fa fa-bus text-muted" aria-hidden="true"></i> 
                    
                    <span class="fw-bold text-muted"> مسیر :  </span> 

                    <span class="fw-bold"> {{ item.strSourceStationName + ' - ' + item.strDestinationStationName }} </span>
                    
                </p>

                <p class=""> 

                    <i class="fa fa-university text-muted" aria-hidden="true"></i>
                    
                    <span class="fw-bold text-muted"> توقف ها :  </span> 

                    <span class="fw-bold" *ngFor="let route of item.lstRoute_Station;let i =index"> 

                        {{ route }}

                        <i *ngIf="i + 1 != item.lstRoute_Station.length"> 
                            
                            {{ ' , ' }} 
                        
                        </i>
                    
                    </span>
                    
                </p>

                <p class=""> 

                    <i class="fa fa-clock-o text-muted" aria-hidden="true"></i> 
                    
                    <span class="fw-bold text-muted">  برنامه حرکت :  </span> 

                    <span class="fw-bold" *ngFor="let Schdeule of item.lstRoute_Schdeule; let i =index"> 

                        {{ Schdeule.strSTime | faNum }}

                        <i *ngIf="i + 1 != item.lstRoute_Schdeule.length"> 
                            
                            {{ ' , ' }} 
                        
                        </i>
                    
                    </span>
                    
                </p>


            </div>
            
        </div>

    </section>

</main>